import { render, staticRenderFns } from "./veStuGraduationAuditConfig.vue?vue&type=template&id=ae44a784&scoped=true"
import script from "./veStuGraduationAuditConfig.vue?vue&type=script&lang=js"
export * from "./veStuGraduationAuditConfig.vue?vue&type=script&lang=js"
import style0 from "./veStuGraduationAuditConfig.vue?vue&type=style&index=0&id=ae44a784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae44a784",
  null
  
)

export default component.exports